export default function Error404Page() {
    return(
        <main className="bg-slate-50 min-h-screen">
            <h1>Error 404, pagina no encontrada</h1>
        </main>
    )
}